<template>
  <div>
    <v-head></v-head>
    <div class="detail_bg">
      <img src="../assets/pic03.png" alt="">
      <div class="detail_txt">
        <div class="title">
          地电波监测机械臂
        </div>
        <div class="txt">
          Geoelectric wave monitoring robot arm
        </div>
      </div>
    </div>
    <div class="detail_content">
      <div>
        <div class="title">项目概况</div> 
        <div class="txt">
          <p>2020年3月份-6月份在上海市市区配电站完成导轨与机械臂的安装部署任务，并开展了为期3个月的性能调试、功能验证及优化改进工作。</p>
        </div> 
      </div>
      <div>
        <div class="title">产品图片</div> 
        <div class="img_one">
          <div class="list_one two">
            <img src="../assets/pic8.png" alt="">
          </div>
        </div> 
        <div class="img_one">
          <div class="list_one one">
            <img src="../assets/pic42.png" alt="">
          </div>
        </div> 
      </div>
    </div>
    <v-foot class="detail_foot"></v-foot>
  </div>
</template>
<script>
import router from '../router/index.js'
export default {
  methods: {
    gotoHome() {
      router.push('/')
    }
  }
}
</script>
<style scoped>

.head {
  position: absolute;
  background-color: #000;
  height: 75px;
  top: 0;
  width: 100%;
}
.head img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.detail_bg img {
  margin-top: 75px;
  width: 100%;  
  height: 600px;  
}
.detail_txt {
  position: absolute;
  top: 280px;
  left: 350px;
  color: #fff ;
}
.detail_txt .title {
  font-size: 58px;
}
.detail_txt .txt {
  margin-top: 32px;
  font-size: 32px;
}
.detail_text {
  display: flex;
}
.detail_content {
  width: 1000px;
  margin: 0 auto;
  color: #666;
}
.detail_content .title {
  font-size: 24px;
  margin-top: 40px;
}
.detail_content .txt {
  margin-top: 15px;
}
.detail_content .txt p {
  font-size: 16px;
  text-indent: 2em;
  margin-top: 3px
}
.img_one {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: 1000px;
  flex: 2;
  justify-content: space-between;
  margin-top: 20px;
}
.img_one .one img {
  width: 1000px;
  height: 450px;
}
.img_one .two img {
  width: 400px;
  height: 400px;
}
.img_one img {
  width: 430px;
  height: 380px;
}
.img_one .img1 {
  width: 450px;
  height: 480px;
}
.img_one .txt {
  margin-top: 6px;
  width: 450px;
  margin-bottom: 10px;
  font-size: 13px;
}
.detail_foot {
  margin-top: 100px;
}

</style>


// WEBPACK FOOTER //
// src/components/Detail7.vue